
<template>
  <div class="faq">
    <header>
      <span class="title">更新日志</span>
      <div class="right">
        <el-button size="small" @click="addOpen()" type="primary" v-if="funAuth.includes(52)">新 建</el-button>
      </div>
    </header>
    <el-table :data='tableData' tooltip-effect='dark' style='width: 100%;height: calc(100% - 122px);' class="el-table-01">
      <el-table-column
        label="更新日期"
        width="200">
        <template slot-scope="scope">
          {{scope.row.title | formatDate('yyyy-MM-dd')}}
        </template>
      </el-table-column>
      <el-table-column
        label="内容"
        width="300">
        <template slot-scope="scope">
          {{scope.row.general_content}}
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="200">
        <template slot-scope="scope">
          {{scope.row.create_time | formatDate('yyyy-MM-dd HH:mm')}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <span class="operator-btn" @click="openEdit(scope.row)" v-if="funAuth.includes(53)">编辑</span>
          <span class="operator-btn" @click="del(scope.row.id)" v-if="funAuth.includes(54)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change='handleSizeChange'
      @current-change='handleCurrentChange'
      :current-page='pageNum'
      :page-sizes='[10, 20, 50, 100]'
      :page-size='pageSize'
      layout='total, sizes, prev, pager, next, jumper'
      :total='tableTotal'>
    </el-pagination>
    <!-- 新增弹窗 -->
    <div class="mask n1" v-if="updateLogDialog"></div>
    <transition name="slide">
      <help-document-create v-if="updateLogDialog"></help-document-create>
    </transition>
  </div>
</template>
<script>
import helpDocumentCreate from './help-document-create.vue'
import { mapState, mapMutations } from 'vuex'
import mixin from '@/common/js/mixins.js'
export default {
  components: {
    helpDocumentCreate
  },
  name: 'FAQ', // 常见问题组件
  mixins: [mixin],
  data () {
    return {
      moduleId: 16, // 模块ID
      dialogAdd: false,
      editorHTML: '',
      currentId: '',
      pageNum: 1,
      pageSize: 10,
      tableTotal: 0,
      tableData: []
    }
  },
  created () {
    this.getMenuDetailList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  methods: {
    // 打开编辑 todo
    openEdit (obj) {
      this.setUpdateLogDialog(true)
      this.setTheme('更新日志')
      this.openEditDialog(obj)
    },
    // 获取列表
    getMenuDetailList () {
      let obj = {
        'menu_id': -2, // -1问题，-2版本更新
        'pageSize': this.pageSize,
        'pageNum': this.pageNum
      }
      this.$http.queryDocList(obj).then(res => {
        this.tableData = res.dataList
        this.pageNum = res.pageInfo.pageNum
        this.pageSize = res.pageInfo.pageSize
        this.tableTotal = res.pageInfo.totalRows
      })
    },
    // 页容量
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.pageNum = 1
      this.getMenuDetailList()
    },
    // 跳页
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      this.getMenuDetailList()
    },
    // 删除列表
    del (id) {
      this.$confirm('确定要删除该数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteDoc({'id': id}).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '操作成功!'
          })
          // 刷新列表
          this.getMenuDetailList()
        })
      })
    },
    // 新建
    addOpen () {
      this.openEditDialog(null)
      this.setTheme('更新日志')
      this.setUpdateLogDialog(true)
    },
    ...mapMutations({
      setUpdateLogDialog: 'UPDATE_LOG_DIALOG', // 开关公共新增弹窗
      openEditDialog: 'OPENEDIT', // 打开公共编辑弹窗
      setTheme: 'THEME' // 设置公共新增弹窗主题
    })
  },
  watch: {
    updateLogDialog () {
      if (!this.updateLogDialog) {
        this.getMenuDetailList()
      }
    }
  },
  computed: {
    ...mapState({
      updateLogDialog: state => state.updateLog.updateLogDialog // 常见问题新增弹窗
    })
  }
}
</script>
<style lang="scss">
.faq {
  height: 100%;
  overflow: auto;
  .span-title {
    margin: 0 15px;
  }
  .el-table{
    .icon-jianjuxiao,.icon-jianjuda {
      cursor: pointer;
      &:hover {
        color: #1890FF;
      }
    }
    .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/help/update-log.vue